import { createGlobalStyle } from "styled-components";
import "@fontsource/raleway";
import "@fontsource/raleway/600.css";
import "@fontsource/raleway/900.css";

export const GlobalStyles = createGlobalStyle`
  body {
    font-family: "Raleway", sans-serif;
    margin: auto;
    overflow-x: hidden;
  }

    body * {
    margin: 0 auto;
    padding: 0;
    box-sizing: border-box;
  }
`;
